<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" inline :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
     
          <el-form-item label="公司" prop="companyId">
              <el-select v-model="dataForm.companyId" filterable clearable placeholder="请选择公司">
                  <el-option
                          v-for="item in companys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
          <el-form-item label="城市" prop="city">
<!--          <el-input v-model="dataForm.city" placeholder="城市"></el-input>-->
              <el-select v-model="dataForm.city" clearable placeholder="请选择">
                  <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
   
      <el-form-item label="预算金额" prop="topLimitMoney" >
          <el-input v-model="dataForm.topLimitMoney"  placeholder="今日预算金额" oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
      </el-form-item>
          <el-form-item label="预算日期" prop="scheduledDate">
<!--          <el-input v-model="dataForm.scheduledDate" placeholder="预算日期"></el-input>-->
              <el-date-picker
                      v-model="dataForm.scheduledDate"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
      </el-form-item>
    
<!--          <el-form-item label="状态（开1、关0）" prop="status">-->
<!--          <el-input v-model="dataForm.status" placeholder="状态（开1、关0）"></el-input>-->
<!--      </el-form-item>-->
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      citys: [],
        companys:[],
      visible: false,
      dataForm: {
        id: '',
        companyId: '',
        city: '',
        topLimitMoney: '',
        scheduledDate: '',
        status: '',
        createBy: '',
        createTime: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        companyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        topLimitMoney: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        scheduledDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
      //初始化下拉框中的选项
      async getCityOptions() {
              this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
                  if (res.code !== 0) {
                      return this.$message.error(res.msg)
                  }
                  this.citys=[];
                  if (res.data!=null){
                      res.data.forEach(element => {
                          this.citys.push({label:element.dictLabel,value:element.dictValue})
                      })
                      /*let citys = {}
                      for(let i = 0; i< res.data.length; i++){
                          citys[i].value=res.data[i].dictValue
                          citys[i].label=res.data[i].dictLabel
                      }*/
                  }
              }).catch(() => {})
      },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
        this.$http.get(`/sys/companies/list`).then(({ data: res }) => {
         
            if (res.code !== 0) {
                return this.$message.error(res.msg)
            }
            this.companys=[];
            if (res.data!=null){
                res.data.forEach(element => {
                    this.companys.push({label:element.name,value:element.id})
                })
            }
        }).catch(() => {})
    },
    init () {
        this.getCityOptions();
        this.getCompanysOptions();
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/budget/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/budget/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style scoped lang="scss">
.line-box{
    display: flex;
    flex-wrap: wrap;
  }
 
</style>